<template>
  <div class="orderLog">
    <FilterForm :fields="searchFields" @submit="getList"/>
    <BasicTable
      showSelect
      border
      hasOperate
      customClass="table"
      :tableData="tableData"
      :pageSize="+pageOption.page_size"
      :currentPage="+pageOption.page"
      :total="+pageOption.total"
      @pageChange="pageChange"
      :treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
      :columns="columns" >
      <template slot="tableOpeate">
        订单日志&emsp;
      </template>
    </BasicTable>
  </div>
</template>

<script>
import { OrderService } from '../../service/order.service';
const columns = [
  { name: '订单编号', key: 'order_sn' },
  { name: '操作人', key: 'username'},
  { name: '操作内容', key: 'msg' },
  { name: '操作时间', key: 'add_time'},
];
const searchFields = [
  { name: '搜索', placeholder: '订单编号/操作人', key: 'search', type: 'input' },
  { name: '操作人员', key: 'operation_type', type: 'select', options: [{ label: '用户', value: '0' }, { label: '管理员', value: '1' }] },
  { name: '开始时间', key: 'start_time', type: 'date' },
  { name: '结束时间', key: 'end_time', type: 'date' },
];
  export default {
    name: 'orderLog',
    props: ['orderId'],
    data() {
      return {
        tableData: [],
        columns,
        searchFields,
        pageOption: {
          page: 1,
          page_size: 20,
          total: 0,
        }
      }
    },
    created() {
      this.getList({})
    },
    methods: {
      async getList(quertField) {
        const query = { ...quertField, page: this.pageOption.page, page_size: this.pageOption.page_size, order_id: this.orderId };
        const data = await OrderService.orderLog(query);
        this.tableData = data.list;
        this.pageOption.page = data.page;
        this.pageOption.total = data.totalRow;
      },
      refreshCurrentList() {
        // this.pageOption.page = 1;
        this.getList(this.searchValues);
      },
      pageChange(index) {
        this.pageOption.page = index;
        this.getList(this.searchValues);
      },
    }
  }
</script>

<style lang="scss" scoped>
.orderLog {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>